export const texts = {
  header: {
    de: 'Sourcing starten',
    en: 'Start sourcing'
  },
  tabDetails: {
    de: 'Details',
    en: 'Details'
  },
  tabJobsite: {
    de: 'Jobsite',
    en: 'Jobsite'
  },
  tabComment: {
    de: 'Kommentar',
    en: 'Comment'
  },
  typeQuestion: {
    de: 'Wie möchtest du vorgehen?',
    en: 'How would you like to proceed?'
  },
  typeLonglist: {
    de: 'Longlist',
    en: 'Longlist'
  },
  typeLonglistBody: {
    de: 'Wir identifizieren passende Talente und stellen dir eine Longlist zusammen. Die Ansprache übernimmst du selbst.',
    en: 'We identify matching talents and compile a longlist for you. You handle the outreach yourself.'
  },
  typeOutreach: {
    de: 'Direktansprache',
    en: 'Direct outreach'
  },
  typeOutreachBody: {
    de: 'Wir identifizieren passende Talente und sprechen sie für dich an. Du erhältst die interessierten Profile.',
    en: 'We identify matching talents and approach them for you. You receive the interested profiles.'
  },
  jobTitle: {
    de: 'Stellentitel',
    en: 'Job title'
  },
  locations: {
    de: 'Arbeitsorte',
    en: 'Locations'
  },
  salary: {
    de: 'Gehalt',
    en: 'Salary'
  },
  to: {
    de: 'bis',
    en: 'to'
  },
  remoteShare: {
    de: 'Remoteanteil',
    en: 'Remote share'
  },
  employmentType: {
    de: 'Anstellungsart',
    en: 'Employment type'
  },
  employmentPermanent: {
    de: 'Festanstellung',
    en: 'Permanent employment'
  },
  employmentInterim: {
    de: 'Befristete Anstellung',
    en: 'Fixed-term employment'
  },
  employmentFreelancer: {
    de: 'Freelancer',
    en: 'Freelancer'
  },
  employmentSelfEmployed: {
    de: 'Selbstständigkeit',
    en: 'Self-employment'
  },
  employmentInternship: {
    de: 'Praktikum',
    en: 'Internship'
  },
  fullTimeLabel: {
    de: 'Vollzeit',
    en: 'Full-time'
  },
  partTimeLabel: {
    de: 'Teilzeit',
    en: 'Part-time'
  },
  yes: {
    de: 'Ja',
    en: 'Yes'
  },
  no: {
    de: 'Nein',
    en: 'No'
  },
  next: {
    de: 'Weiter',
    en: 'Continue'
  },
  startOutreach: {
    de: 'Ansprache starten',
    en: 'Start outreach'
  },
  jobsiteCheck: {
    de: 'Möchtest du die Jobsite anschauen und Feedback geben (auch nach Beauftragung noch möglich)?',
    en: 'Would you like to take a look at the jobsite and give us feedback (still possible after starting)?'
  },
  viewJobsite: {
    de: 'Jobsite ansehen',
    en: 'View jobsite'
  },
  anythingToTell: {
    de: 'Möchtest du uns noch etwas mitteilen?',
    en: 'Is there anything else you’d like to tell us?'
  },
  back: {
    de: 'Zurück',
    en: 'Back'
  },
  startPaid: {
    de: 'Kostenpflichtig starten',
    en: 'Start (paid)'
  },
  thankYou: {
    de: 'Vielen Dank!',
    en: 'Thank you!'
  },
  processed: {
    de: 'Deine Stelle wird nun bearbeitet.',
    en: 'Your position is now being processed.'
  },
  close: {
    de: 'Schließen',
    en: 'Close'
  }
};
